module.exports = __webpack_public_path__ + "img/facebook-logo.3162f83b.svg";